import { UserProfile } from '@/services/ProfileService';
import { ActivityLog } from './LearnTypes';

/**
 * Enum for categorizing achievements
 */
export enum AchievementCategory {
  XP_MILESTONE = 'xp_milestone',
  DAILY_ACTIVITY = 'daily_activity',
  STREAK = 'streak',
  PERFECT_PERFORMANCE = 'perfect_performance',
  LESSON_COMPLETION = 'lesson_completion'
}

/**
 * Interface for achievement definitions
 */
export interface AchievementDefinition {
  id: string;               // Unique identifier
  title: string;            // Display name
  description: string;      // User-friendly description
  icon: string;             // Icon/badge reference
  category: AchievementCategory;  // For grouping/filtering
  tier?: number;            // For related achievements with progression (1, 2, 3...)
  xpReward?: number;        // Optional XP bonus for earning
  condition: (user: UserProfile, activities: ActivityLog[]) => boolean;  // Function to determine if achieved
}

/**
 * Interface for an achievement that has been earned by a user
 */
export interface EarnedAchievement {
  id: string;               // Reference to achievement definition
  earnedAt: Date;           // When it was earned
  viewed: boolean;          // Has user seen the full-page notification
}

/**
 * New activity type for logging earned achievements
 */
export interface AchievementActivity extends Omit<ActivityLog, 'lessonId' | 'lessonName' | 'levelIndex' | 'levelType' | 'isPerfect' | 'isPerfectLesson'> {
  type: 'achievement-earned';
  achievementId: string;
  achievementTitle: string;
}
